import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';

export enum AppProtectionStatus {
	Enabled = 'on',
	RequiresWebExtension = 'requireswebextension',
	Disabled = 'off',
}

export class AppProtectionConfigAccessor {
	private workspaceConfiguration: WorkspaceConfiguration;

	public constructor(workspaceConfiguration: WorkspaceConfiguration) {
		this.workspaceConfiguration = workspaceConfiguration;
	}

	public isAppProtectionEnabledByAdmin(): boolean {
		return (
			this.workspaceConfiguration?.appProtection?.enabled?.toLowerCase() ===
			AppProtectionStatus.Enabled
		);
	}

	public isAppProtectionEnabledWithBrowserExtensionMandateByAdmin(): boolean {
		return (
			this.workspaceConfiguration?.appProtection?.enabled?.toLowerCase() ===
			AppProtectionStatus.RequiresWebExtension
		);
	}

	public isAppProtectionDisabledByAdmin(): boolean {
		return (
			this.workspaceConfiguration?.appProtection?.enabled?.toLowerCase() ===
			AppProtectionStatus.Disabled
		);
	}

	public shouldConditionallyAddAppProtectionHeader(): boolean {
		return (
			this.isAppProtectionEnabledByAdmin() ||
			this.isAppProtectionEnabledWithBrowserExtensionMandateByAdmin()
		);
	}
}
